import { OK_MESSAGE } from '@baeso-ui/baeso-core';
import { BooleanProperty, ObjectProperty, ObjectPropertyN, } from '@baeso-ui/baeso-observable';
export class FormControl {
    constructor(init) {
        this.value = (init === null || init === void 0 ? void 0 : init.value) ? init.value : new ObjectProperty('value');
        this.disabled = (init === null || init === void 0 ? void 0 : init.disabled) ? init.disabled : new BooleanProperty('disabled', false);
        this.message = new ObjectPropertyN('message', OK_MESSAGE);
    }
}
